import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Sub-tabs for Other Discipline tab
const OTHER_TABS = [
  { label: 'Priority', value: 'Priority' },
  { label: 'General', value: 'General' },
  { label: 'Other', value: 'Other' },
  { label: 'Uncategorized', value: 'Uncategorized' }
  // Add/remove categories here
];

export default function ProgramSection() {
  // Teams/Disciplines (original)
  const [teams, setTeams] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const [loadingTeams, setLoadingTeams] = useState(true);
  const [loadingDisciplines, setLoadingDisciplines] = useState(true);

  // Main tab state
  const [tab, setTab] = useState("teams");

  // Other Discipline tab state
  const [otherTab, setOtherTab] = useState(OTHER_TABS[0].value);
  const [otherDisciplines, setOtherDisciplines] = useState([]);
  const [loadingOther, setLoadingOther] = useState(true);
  const [otherError, setOtherError] = useState("");

  // Session name state
  const [sessionName, setSessionName] = useState("");
  const [loadingSessionName, setLoadingSessionName] = useState(true);

  // Fetch teams
  useEffect(() => {
    setLoadingTeams(true);
    fetch("/api/home/overall-team-summary")
      .then(res => res.json())
      .then(data => setTeams(data))
      .finally(() => setLoadingTeams(false));
  }, []);

  // Fetch Other Discipline tab data
  useEffect(() => {
    if (tab === "other") {
      setLoadingOther(true);
      setOtherError("");
      fetch(`/api/DisciplineOther/${otherTab}`)
        .then(res => {
          if (!res.ok) throw new Error("No data found.");
          return res.json();
        })
        .then(data => setOtherDisciplines(data))
        .catch(e => setOtherError(e.message))
        .finally(() => setLoadingOther(false));
    }
  }, [tab, otherTab]);

  // Fetch session name (plain string like "2024-2025")
  useEffect(() => {
    setLoadingSessionName(true);
    fetch("/api/home/session-name")
      .then(res => res.text())
      .then(data => setSessionName(data)) // Works for plain string response!
      .catch(() => setSessionName(""))
      .finally(() => setLoadingSessionName(false));
  }, []);

  return (
    <section id="program" className="parallax-section">
      <div className="container">
        <div className="row">
          <div className="wow fadeInUp col-md-12 col-sm-12 text-center" data-wow-delay="0.6s">
            <div className="section-title">
              <h2>Event Overview</h2>
              <p>
                Explore all the participating teams and disciplines involved in our events.
              </p>
            </div>
          </div>
          <div className="wow fadeInUp col-md-10 col-sm-12 col-md-offset-1" data-wow-delay="0.9s">
            {/* Nav tabs */}
            <ul className="nav nav-tabs" role="tablist">
              <li className={tab === "teams" ? "active" : ""}>
                <a href="#teams" aria-controls="teams" role="tab" data-toggle="tab"
                  onClick={e => { e.preventDefault(); setTab("teams"); }}>Teams</a>
              </li>
              <li className={tab === "other" ? "active" : ""}>
                <a href="#other" aria-controls="other" role="tab" data-toggle="tab"
                  onClick={e => { e.preventDefault(); setTab("other"); }}>Disciplines</a>
              </li>
            </ul>
            {/* Tab panes */}
            <div className="tab-content">
              {/* Teams Tab */}
              <div className="table-responsive chart-no-select">
                {loadingTeams ? (
                  <p style={{ textAlign: "center" }}>Loading teams...</p>
                ) : (
                  <table className="table table-hover table-bordered">
                    <thead>
                      <tr>
                        <th>Team</th>
                        <th>Events Participated</th>
                        <th>Total Participants</th>
                      </tr>
                    </thead>
                    <tbody>
                        {teams.length === 0 ? (
                          <tr>
                            <td colSpan={3} className="text-center">No teams found.</td>
                          </tr>
                        ) : (
                          teams.map((team, idx) => (
                            <tr key={team.loginId || idx}>
                              <td>
                                <Link
                                  to={`/kshetra/${encodeURIComponent((team.loginId || '').trim())}`}
                                  style={{ color: "#0073e6", textDecoration: "underline" }}
                                >
                                  {team.heading}
                                </Link>
                              </td>
                              <td>{team.games}</td>
                              <td>{team.total}</td>
                            </tr>
                          ))
                        )}
                      </tbody>

                  </table>
                )}
              </div>
              {/* End Teams tab */}

              {/* Other Discipline Tab */}
              <div
                role="tabpanel"
                className={`tab-pane${tab === "other" ? " active" : ""}`}
                id="other"
              >
                {/* Sub-tabs for Other Discipline */}
                <div style={{ margin: "16px 0" }}>
                  <ul className="nav nav-pills" style={{ marginBottom: "1rem" }}>
                    {OTHER_TABS.map(ot => (
                      <li key={ot.value} className={otherTab === ot.value ? "active" : ""}>
                        <a
                          href="#"
                          onClick={e => { e.preventDefault(); setOtherTab(ot.value); }}
                          style={{
                            borderRadius: "8px",
                            background: otherTab === ot.value ? "#111" : "#333",
                            color: "#fff",
                            padding: "10px 28px",
                            marginRight: "8px",
                            fontWeight: otherTab === ot.value ? "bold" : "normal",
                            fontSize: "15px",
                            border: "none",
                            display: "inline-block",
                            transition: "all 0.18s"
                          }}
                        >
                          {ot.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                  {loadingOther ? (
                    <p style={{ textAlign: "center" }}>Loading {otherTab} disciplines...</p>
                  ) : otherError ? (
                    <div className="alert alert-danger text-center">{otherError}</div>
                  ) : (
                    <div className="table-responsive chart-no-select">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Discipline</th>
                            <th>No of Subdiscipline</th>
                            <th>DType</th>
                          </tr>
                        </thead>
                        <tbody>
                          {otherDisciplines.length === 0 ? (
                            <tr>
                              <td colSpan={4} className="text-center">No records found.</td>
                            </tr>
                          ) : (
                            otherDisciplines.map((item, idx) => (
                              <tr key={item.sNo || idx}>
                                <td>{item.sNo}</td>
                                <td>{item.discipline}</td>
                                <td>{item.noOfSubdiscipline}</td>
                                <td>{item.dType}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
              {/* End Other Discipline tab */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
